import { XMLInterfaceObject } from "@goodgamestudios/core";
import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { int } from "@goodgamestudios/math-utilities";
import { VisualVO } from "./VisualVO";

export class AchievementsVO extends VisualVO {
    public currentLevel: number = 0;
    public maxLevel: number = 0;

    public steps: any[];
    public points: number = 0;
    public baseEarnXP: number = 0;
    public baseEarnChips: number = NaN;
    public bonusAP: number = 0;
    public bonusXP: number = 0;
    private _amount: number = NaN;

    constructor() {
        CONSTRUCTOR_HACK;
        super();
    }

    public getVisClassName(): string {
        return "achievement_" + this.id.toString();
    }

    public fillFromParamXML(wodElement: XMLInterfaceObject): void {
        //maxSteps step1 step2 step3 step4 step5 step6 step7 step8 step9 step10 step11 step12 step13 step14 step15 points chips xpValue
        super.fillFromParamXML(wodElement);
        this.maxLevel = int((wodElement['maxSteps'] || ''));
        this.steps = [0];
        for (var i: number = 1; i < this.maxLevel + 1; i++) {
            var stepAttribute: string = wodElement["step" + i];
            stepAttribute = stepAttribute.replace(",", ".");
            this.steps.push(Number(stepAttribute));
        }
        this.points = int((wodElement['points'] || ''));
        this.baseEarnXP = parseInt((wodElement['xpValue'] || ''));
        this.baseEarnChips = parseFloat((wodElement['chips'] || ''));
    }

    public get amount(): number {
        return this._amount;
    }

    public set amount(value: number) {
        this._amount = value;
    }

}
classImplementsInterfaces(AchievementsVO, "IInventoryVO");
